import { createElement, useEffect, useRef } from 'react';
import styled from 'styled-components';
import * as echarts from 'echarts';
import throttle from 'lodash/throttle';
import { isDef, judgeObj } from '../../utils';
const WrapperStyle = styled.div `
  padding: ${(props) => props.hasTitle ? '14px' : '0'};
  border: ${(props) => props.hasBorder ? '1px solid #D8D8D8' : 'none'};
  background: #fff;
  .title {
    margin-bottom: 24px;
    font-family: PingFang SC;
    font-size: 16px;
    font-weight: 600;
    line-height: 20px;
    letter-spacing: 0px;
  }
  .echart-dom {
    width: 100%;
    height: 300px;
    overflow: hidden;
  }
`;
const defaultStyle = { minHeight: 300, width: '100%', height: '300px', overflow: 'hidden' };
const Echarts = ({ hasCard = false, title, option, customOption, borderd = false, style }) => {
    if (typeof customOption === 'function') {
        option = customOption({ echarts });
    }
    console.log('option', option);
    if (!judgeObj(option)) {
        console.error('温馨提示：option数据结构不对，无法渲染，请检查');
        return null;
    }
    const ref = useRef(null);
    const myChartInstance = useRef(null);
    const echartDom = createElement("div", { className: "echart-dom", ref: ref, style: { ...defaultStyle, ...style } });
    useEffect(() => {
        myChartInstance.current = echarts.init(ref.current);
        myChartInstance.current.setOption(option);
        const resizeFun = throttle(() => myChartInstance.current.resize(), 100);
        window.addEventListener('resize', resizeFun);
        return () => {
            window.removeEventListener('resize', resizeFun);
        };
    }, [hasCard]);
    useEffect(() => {
        if (!isDef(myChartInstance.current)) {
            return;
        }
        myChartInstance.current.setOption(option);
    }, [hasCard, option]);
    return hasCard ? createElement(WrapperStyle, { hasTitle: !!title, hasBorder: borderd },
        title && createElement("div", { className: "title" }, title),
        echartDom) : echartDom;
};
Echarts.displayName = 'Echarts';
export default Echarts;
